/* @flow strict */

import * as React from 'react';
import Modal from './../Modal';
import './styles.scss';

type PropsType = {
  handleShow: (boolean) => void,
  callback: (any) => void
};

const StripeConnectWarningDialog = ({ handleShow, callback }: PropsType): React.Element<'div'> => {
  return (
    <Modal
      opened
      onClose={() => {
        handleShow(false);
      }}
      top0
    >
      <div className="modal-dialog customModal ConfirmDialog" role="document">
        <div className="modal-content">
          <div className={'sparxo-pop md-content warning'}>
            <div className="sparxo-pop-left" />

            <div className="sparxo-pop-right">
              <h3 className="sparxo-pop-title">Connect to Stripe</h3>

              <p className="sparxo-pop-content">
                Looks like you have a paid event.
                Sparxo has teamed up with Stripe to help you easily collect payments.
                You'll need to connect to Stripe to start ticket sales.
                Don't worry, your event has been saved and you can resume
                creating your experience when you are done connecting your Stripe account.
              </p>

              <div className="sparxo-pop-buttons">
                <button
                  className="btn-gray"
                  onClick={() => {
                    handleShow(false);

                    callback(false);
                  }}
                >
                  Skip
                </button>

                <button
                  className="btn-pink"
                  onClick={() => {
                    handleShow(false);

                    callback(true);
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default StripeConnectWarningDialog;
